/** Número de líneas visibles por defecto cuando el texto está colapsado. */
export const DEFAULT_COLLAPSED_LINES = 3

/** Etiqueta del disparador cuando el texto está colapsado. */
export const LABEL_EXPAND = 'Ver más'

/** Etiqueta del disparador cuando el texto está expandido. */
export const LABEL_COLLAPSE = 'Ver menos'

/**
 * Factor de respaldo para estimar `line-height` cuando el valor computado es
 * `normal` (no numérico): se multiplica por el `font-size` real del elemento.
 */
export const LINE_HEIGHT_FALLBACK_RATIO = 1.5

/** Holgura en px al comparar altura natural vs. colapsada (evita falsos positivos). */
export const OVERFLOW_TOLERANCE_PX = 1
